<template>
  <b-row>
    <b-col>
      <h5>เลือกผู้ที่เห็นงาน</h5>
      <span v-if="jobPrivate && vendorGroup.length <= 0" class="logisty-custom-invalid-feedbace mb-2">กรุณาเลือกกลุ่มที่สร้างไว้</span>
      <div class="mt-2">
        <!-- <b-row>
          <b-col>
            <span v-if="companySelected.length < 1 && vendorGroup.length < 1" class="logisty-custom-invalid-feedbace mb-2">จำเป็นต้องเลือกกลุ่มหรือรายชื่อบริษัท</span>
            <b>เลือกตามชื่อผู้ใช้</b>
            <b-form-group>
              <label for="searchName">ค้นหาชื่อผู้ใช้</label>
              <b-input-group>
              <b-form-input
                v-model="searchName"
                type="text"
                id="searchName"
                placeholder="ตัวอย่าง: สุขสวัสดิ์ขนส่ง"
                :disabled="disableReboardcast"
              ></b-form-input>
              <b-input-group-append>
                <b-button v-on:click="searchCompany" variant="primary" :disabled="disableReboardcast">ค้นหา</b-button>
              </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row> -->

        <!-- <b-row v-if="selectList.length > 0">
          <b-col sm="12">
            <b-form-group label="รายชื่อที่เลือก">
              <b-form-checkbox
                v-for="option in selectList"
                v-model="companySelected"
                :key="option._id"
                :value="option._id"
                stacked
                :disabled="disableReboardcast"
                @input="onFormFocus('private-company-selected')"
              >{{ option.name }}</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="searchResult.length > 0">
          <b-col sm="12">
            <b-form-group label="ผลการค้นหา">
              <b-form-checkbox
                v-for="option in searchResult"
                v-model="companySelected"
                :key="option._id"
                :value="option._id"
                stacked
                :disabled="disableReboardcast"
              >{{ option.name }}</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-radio-group
                id="jobPrivate"
                v-model="jobPrivate"
                :options="boardcastOptions"
                size="sm"
                name="radio-btn-outline"
                :disabled="disableReboardcast"
                @input="onFormFocus('private-select')"
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div v-if="jobPrivate">

          <b-row>
            <b-col>
              <b-form-group label="รายชื่อที่เลือก">
                <b-form-checkbox
                  v-for="option in vendorGroupList"
                  v-model="vendorGroup"
                  :key="option._id"
                  :value="option._id"
                  stacked
                  @input="onFormFocus('private-vendor-selected')"
                >{{ option.name }}</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <h5>ตัวเลือกเพิ่มเติม</h5>
        <b-row>
          <b-col lg="6" xl="4">
            <MultiSelectTag
              label="ท่านสามารถเลือกไม่ให้บางบริษัทเห็นงานของท่านได้ โดยเลือกได้จากรายชื่อด้านล่าง"
              v-model="companyExcluded"
              :options="companyTagList"
              trackBy="_id"
              labelBy="name"
            />
            <span></span>
          </b-col>
        </b-row>

      </div>
    </b-col>
  </b-row>
</template>

<script>
import Company from '../../services/http/Company'

import MultiSelectTag from '../../components/MultiSelectTag'

export default {
  name: 'DashboardJobPrivateJobForm',
  components: {
    MultiSelectTag
  },
  props: {
    updateAction: {
      default: false,
      required: false
    },
    propJobPrivate: {
      default: false,
      required: false
    },
    propVendorGroup: {
      default: function () {
        return []
      },
      required: false
    },
    propCompanyExcuted: {
      default: function () {
        return []
      },
      required: false
    },
    propCompanySelected: {
      default: function () {
        return []
      },
      required: false
    }
  },
  data () {
    return {
      jobPrivate: false, // return
      boardcastOptions: [
        { text: 'ทุกคนในระบบLogisty', value: false },
        { text: 'เลือกตามกลุ่มที่สร้างไว้', value: true }
      ],
      vendorGroup: [], // return
      vendorGroupList: [],
      companyListAll: [],
      companyAllList: [],
      searchName: null,
      searchResult: [],
      companySelected: [], // return
      selectList: [],
      disableReboardcast: false,
      companyExcluded: [],
      companyTagList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      var company = new Company()
      var vendorGroup = await company.getVendorGroupAll()
      this.vendorGroupList = vendorGroup.data

      var companies = await company.getCompanyAll()
      if (companies.code === 1) {
        this.companyListAll = companies.data
        let companyListTemp = this.companyListAll.filter((x) => {
          if (x._id !== this.$cookies.get('companyId')) {
            return x
          }
        })
        this.companyTagList = companyListTemp.map((x) => {
          return {
            _id: x._id,
            name: x.name
          }
        })
      }

      if (this.updateAction) {
        this.jobPrivate = this.propJobPrivate
        this.vendorGroup = this.propVendorGroup
        this.companySelected = this.propCompanySelected
        this.companyExcluded = this.propCompanyExcuted
        this.updateMemberForm()
      }
    },
    searchCompany () {
      this.updateMemberForm()
    },
    updateMemberForm () {
      this.updateSearchResult()
      this.updateList()
    },
    updateSearchResult () {
      this.searchResult = this.companyListAll.filter(
        (company) => {
          if (company.name && company.name.includes(this.searchName)) {
            return company
          }
        }
      )
    },
    updateList () {
      // console.log(this.companySelected)
      var list = []
      for (var i = 0; i < this.companySelected.length; i++) {
        list.push(this.companyListAll.find(
          x => x._id === this.companySelected[i]
        ))
      }

      this.selectList = list

      var newList = this.searchResult
      for (var i = 0; i < this.companySelected.length; i++) {
        newList = newList.filter(
          x => x._id !== this.companySelected[i]
        )
      }
      // console.log(newList)
      this.searchResult = newList
    },
    onFormFocus (name) {
      window.analytics.track('private-form-focus-' + name)
    }
  },
  watch: {
    companySelected (newVal, oldVal) {
      // this.searchCompany()
      this.updateMemberForm()
    },
    vendorGroup () {
      this.updateMemberForm()
    }
  }
}
</script>
